module.exports = __webpack_public_path__ + "img/06.421cb2d9.png";